import JSONAPISerializer from '@ember-data/serializer/json-api';

export default class BaseItemSerializer extends JSONAPISerializer {
  keyForAttribute(attr) {
    return attr;
  }
  normalize(typeHash, hash) {
    if (hash.attributes) {
      if (hash.attributes.status === 'O' || !hash.attributes.status) {
        hash.attributes.status = false;
      } else {
        hash.attributes.status = true;
      }
    }
    return super.normalize(typeHash, hash);
  }
  serialize() {
    let json = super.serialize(...arguments);

    if (
      json.data?.attributes?.updated_at ||
      json.data?.attributes?.updated_at == null
    ) {
      delete json.data.attributes.updated_at;
    }
    return json;
  }
}
